import { styled } from 'styled-components';
import { ThemeProps } from '../../themes';

export const ActionBarType = {
    action: 'action',
    info: 'info',
} as const;

export const Root = styled.div<{ $actionBarType?: keyof typeof ActionBarType } & ThemeProps>`
    display: flex;
    align-items: flex-start; /* let left stack grow vertically */
    gap: ${({ theme }) => theme.spacing(3)};
    padding-block: ${({ theme }) => theme.spacing(4)};
    padding-inline: 48px;
    box-sizing: border-box;
    width: 100%;
    background-color: ${({ $actionBarType, theme }) =>
        $actionBarType === ActionBarType.action
            ? theme.background.attention
            : theme.background.banner};
    min-height: 44px; /* auto height (no fixed 51px) */
`;

export const LeftContainer = styled.div<ThemeProps>`
    flex: 1 1 auto;
    min-width: 0; /* allow text ellipsis/clamp to work */
    display: flex;
    flex-direction: column; /* stack header + description */
    gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const RightContainer = styled.div<ThemeProps>`
    flex: 0 0 auto; /* NEVER grow */
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
`;

/* Utility wrapper to clamp long text */
export const Clamp = styled.div<{ lines?: number }>`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${({ lines }) => lines ?? 2};
    overflow: hidden;
`;
